const TOUCH_START = typeof window === 'object' && 'ontouchstart' in window ? 'touchstart' : 'mousedown';
const TOUCH_MOVE = typeof window === 'object' && 'ontouchmove' in window ? 'touchmove' : 'mousemove';
const TOUCH_END = typeof window === 'object' && 'ontouchend' in window ? 'touchend' : 'mouseup';

/**
 * 注册一个事件
 * @param {*} selector
 * @param {*} type
 * @param {*} callback
 * @param {*} opts
 */
const on = (selector, type, callback = () => {}) => {
    selector.addEventListener(type, e => {
        callback.call(this, e);
    });
};

/**
 * 获取触摸位置的坐标
 * @param {any} e
 * @param {any} xy
 * @param {any} isEnd
 */
const getEventPageXY = (e, xy, isEnd = false) => {
    e = e || window.event;
    xy = xy === 'x' ? 'pageX' : 'pageY';
    const useTouch = 'ontouchstart' in window;

    if (!useTouch) {
        return e[xy];
    } else if (isEnd) {
        return e.changedTouches[0][xy];
    } else {
        return e.touches[0][xy];
    }
};

/**
 * 移动端滑动事件
 * @param {*} ele
 * @param {*} startCallback
 * @param {*} movCallback
 * @param {*} endCallback
 * @param {*} opts
 */
const swip = (
    ele,
    startCallback = () => {},
    moveCallback = (begin, current) => {},
    endCallback = () => {},
    opts = {},
) => {
    let beginX = 0;
    let beginY = 0;
    let endX = 0;
    let endY = 0;
    let actualDirect = 'unknown';

    on(
        ele,
        TOUCH_START,
        e => {
            beginX = getEventPageXY(e, 'x');
            beginY = getEventPageXY(e, 'y');
            startCallback.call(this, beginX, beginY);
        },
        opts,
    );

    on(
        ele,
        TOUCH_MOVE,
        e => {
            const movX = getEventPageXY(e, 'x');
            const movY = getEventPageXY(e, 'y');
            let result = '';

            // 计算一个真实的滑动方向
            if (actualDirect === 'unknown') {
                if (Math.abs(movX - beginX) > Math.abs(movY - beginY)) {
                    actualDirect = 'horizontal';
                } else {
                    actualDirect = 'vertical';
                }
            }

            // 业务逻辑代码
            if (typeof opts.direct !== 'undefined') {
                if (opts.direct === 'horizontal') {
                    result = moveCallback.call(this, beginX, movX, actualDirect);
                } else {
                    result = moveCallback.call(this, beginY, movY, actualDirect);
                }
            } else if (actualDirect === 'horizontal') {
                result = moveCallback.call(this, beginX, movX, actualDirect);
            } else {
                result = moveCallback.call(this, beginY, movY, actualDirect);
            }

            if (result === false) {
                e.preventDefault();
                e.stopPropagation();
            }
        },
        opts,
    );

    on(
        ele,
        TOUCH_END,
        e => {
            endX = getEventPageXY(e, 'x', true);
            endY = getEventPageXY(e, 'y', true);
            if (typeof opts.direct !== 'undefined') {
                if (opts.direct === 'horizontal') {
                    endCallback.call(this, beginX, endX, actualDirect);
                } else {
                    endCallback.call(this, beginY, endY, actualDirect);
                }
            } else if (actualDirect === 'horizontal') {
                endCallback.call(this, beginX, endX, actualDirect);
            } else {
                endCallback.call(this, beginY, endY, actualDirect);
            }
        },
        opts,
    );
};

// 轻触屏幕
const tap = (elm, startCallBaack = () => {}, endCallback = (tapX, tapY) => {}, options = {}) => {
    const duration = options.duration || 0;
    const fixDistance = options.fixDistance || 10;
    let startTime = 0;
    let endTime = 0;
    let startPageX = 0;
    let startPageY = 0;
    let endPageX = 0;
    let endPageY = 0;

    on(elm, TOUCH_START, e => {
        startTime = new Date().valueOf();
        startPageX = getEventPageXY(e, 'x');
        startPageY = getEventPageXY(e, 'y');
        startCallBaack.call(this, startPageX, startPageY);
    });

    on(elm, TOUCH_END, e => {
        let result = true;

        endTime = new Date().valueOf();
        endPageX = getEventPageXY(e, 'x', true);
        endPageY = getEventPageXY(e, 'y', true);

        if (
            endTime - startTime > duration &&
            (Math.abs(endPageX - startPageX) < fixDistance ||
            Math.abs(endPageY - startPageY) < fixDistance)
        ) {
            result = endCallback.call(this, endPageX, endPageY);
        }

        endCallback.call(this, endPageX, endPageY)

        if (result === false) {
            e.preventDefault();
            e.stopPropagation();
        }
    });
};

export default swip;
export { swip, tap };
